

type GroupByKeySelectorFunction<Type> = (element: Type, index: number, arr: Type[]) => string
type GroupByKeySelector<Type> = GroupByKeySelectorFunction<Type> | keyof Type

export function groupBy<Type>(values: Type[], keyFinder: GroupByKeySelector<Type>): Record<string, Type[]> {
  // using reduce to aggregate values
  return values.reduce((a: Record<string, Type[]>, b, i, arr) => {
    // depending upon the type of keyFinder
    // if it is function, pass the value to it
    // if it is a property, access the property
    const key = typeof keyFinder === 'function' ? keyFinder(b, i, arr) : b[keyFinder];
    
    // aggregate values based on the keys
    if(!(key as string in a)){
      a[key as string] = [b];
    }else{
      a[key as string] = [...a[key as string], b];
    }
    
    return a;
  }, {});
}